import { FC, HTMLAttributes } from 'react';

import { headingsPlugin, listsPlugin, MDXEditor, quotePlugin, thematicBreakPlugin } from '@mdxeditor/editor';

import { Flex } from 'antd';

import { TaskAttachments } from 'entities/Task';
import { OfferAttachmentRead } from 'shared/api/client/codegen.api';

import '@mdxeditor/editor/style.css';

import styles from './OfferOverview.module.scss';

interface IPreviewTaskProps extends HTMLAttributes<HTMLDivElement> {
	description?: string;
	attachments?: OfferAttachmentRead[];

}

export const OfferOverview: FC<IPreviewTaskProps> = ({ attachments, description }) => {
	return (
		<Flex vertical gap={4} className={styles.content}>
			<MDXEditor
				contentEditableClassName={styles.editor}
				markdown={description || ''}
				readOnly
				plugins={[headingsPlugin(), listsPlugin(), quotePlugin(), thematicBreakPlugin()]}
			/>
			<TaskAttachments files={attachments} />
		</Flex>
	);
};
